import { use } from 'react'
import { ProductsContext } from './ProductsContext'

export function useProductsContext() {
  const context = use(ProductsContext)
  if (!context) {
    throw new Error(
      'useProductsContext must be used within a ProductsProvider',
    )
  }
  return context
}
